<template>
  <section class="app-transporte">
    <v-container grid-list-xl>

      <!-- LOADING PADRÃO -->
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
        class="mb-4"
      />

      <h2 class="mb-4">Dashboard</h2>

      <v-row>
        <v-col cols="12" md="3">
          <DashboardCard
            situacao="Vereadores em Mandato"
            :count="vereadoresEmMandato"
            icon="groups"
          />
        </v-col>

        <v-col cols="12" md="3">
          <DashboardCard
            situacao="Vagas Disponíveis"
            :count="vagasDisponiveis"
            icon="check_circle"
          />
        </v-col>

        <v-col cols="12" md="3">
          <DashboardCard
            situacao="Veículos com Vigência a Vencer"
            :count="veiculosAVencer"
            icon="directions_car"
          />
        </v-col>

        <v-col cols="12" md="3">
          <DashboardCard
            situacao="Veículos com Vigência Expirada"
            :count="veiculosComVigenciaExpirada"
            icon="warning"
          />
        </v-col>
      </v-row>

    </v-container>
  </section>
</template>

<script>
import DashboardCard from './components/DashboardCard.vue';
import cpvService from '@/services/cpv/cpv.service';
import GlobalStore from '@/store/modules/global';

export default {
  name: 'CPVDashboard',

  components: { DashboardCard },

  data() {
    return {
      loading: false,

      vereadoresEmMandato: 0,
      vagasDisponiveis: 0,
      veiculosAVencer: 0,
      veiculosComVigenciaExpirada: 0,
    };
  },

  created() {
    this.carregarDashboard();
  },

  methods: {
    carregarDashboard() {
      const PresidenteId = this.getPresidenteIdFromCache();

      this.loading = true;

      cpvService.retriveDashboardData(PresidenteId)
        .subscribe({
          next: res => {
            const result = res?.result;

            this.vereadoresEmMandato = Number(result?.vereadoresEmMandato || 0);
            this.vagasDisponiveis = Number(result?.vagasDisponiveis || 0);
            this.veiculosAVencer = Number(result?.veiculosComVigenciaAVencer || 0);
            this.veiculosComVigenciaExpirada = Number(result?.veiculosComVigenciaExpirada || 0);
          },
          error: () => {
            this.loading = false;
          },
          complete: () => {
            this.loading = false;
          },
        });
    },

    getPresidenteIdFromCache() {
      const token = localStorage.getItem('cpv_token');
      if (!token) return null;

      try {
        const payload = token.split('.')[1];
        const decoded = JSON.parse(atob(payload));
        return decoded?.sub || null;
      } catch {
        return null;
      }
    },
  },
};
</script>
